'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../../constants/sizes');

var _colors = require('../../../constants/colors');

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefaultIcon = function DefaultIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'defs',
            null,
            _react2.default.createElement('path', {
                id: 'a',
                d: 'M0 48.75h60V0H0z'
            })
        ),
        _react2.default.createElement(
            'g',
            {
                transform: 'translate(0 .4)',
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement(
                'mask',
                {
                    id: 'b',
                    fill: '#fff'
                },
                _react2.default.createElement('use', {
                    xlinkHref: '#a'
                })
            ),
            _react2.default.createElement('path', {
                fill: '#3F5060',
                mask: 'url(#b)',
                d: 'M47.813 23.438H60v-1.875H47.812zM33.75 23.438H45v-1.875H33.75zM0 23.438h30v-1.875H0z'
            }),
            _react2.default.createElement('path', {
                d: 'M45.938 41.25h-1.876V6.562A6.57 6.57 0 0 1 50.626 0a6.57 6.57 0 0 1 6.563 6.563V22.5h-1.876V6.562a4.693 4.693 0 0 0-4.687-4.687 4.693 4.693 0 0 0-4.688 4.688V41.25zM30.938 41.25h-1.875V6.562A6.57 6.57 0 0 1 35.624 0a6.57 6.57 0 0 1 6.563 6.563v5.625h-1.876V6.561a4.693 4.693 0 0 0-4.687-4.687 4.693 4.693 0 0 0-4.688 4.688V41.25zM40.313 22.5h1.874v-4.688h-1.874z',
                fill: '#3F5060',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                fill: '#3F5060',
                mask: 'url(#b)',
                d: 'M30 30.938h15v-1.875H30zM30 15.938h15v-1.876H30z'
            }),
            _react2.default.createElement('path', {
                d: 'M52.5 48.107a6.2 6.2 0 0 1-4.413-1.828 4.37 4.37 0 0 0-6.174 0 6.2 6.2 0 0 1-4.413 1.828 6.2 6.2 0 0 1-4.413-1.828 4.37 4.37 0 0 0-6.174 0 6.2 6.2 0 0 1-4.413 1.828 6.2 6.2 0 0 1-4.413-1.828 4.37 4.37 0 0 0-6.174 0A6.2 6.2 0 0 1 7.5 48.107a6.2 6.2 0 0 1-4.413-1.828A4.336 4.336 0 0 0 0 45v-1.875c1.667 0 3.234.649 4.413 1.828A4.336 4.336 0 0 0 7.5 46.232a4.336 4.336 0 0 0 3.087-1.279 6.247 6.247 0 0 1 8.826 0 4.336 4.336 0 0 0 3.087 1.279 4.336 4.336 0 0 0 3.087-1.279 6.247 6.247 0 0 1 8.826 0 4.336 4.336 0 0 0 3.087 1.279 4.336 4.336 0 0 0 3.087-1.279 6.247 6.247 0 0 1 8.826 0 4.336 4.336 0 0 0 3.087 1.279 4.336 4.336 0 0 0 3.087-1.279A6.197 6.197 0 0 1 60 43.125V45a4.336 4.336 0 0 0-3.087 1.279 6.2 6.2 0 0 1-4.413 1.828',
                fill: '#A7F2EB',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                d: 'M52.5 41.544a6.2 6.2 0 0 1-4.413-1.828A4.336 4.336 0 0 0 45 38.437a4.336 4.336 0 0 0-3.087 1.28 6.205 6.205 0 0 1-4.368 1.827 6.202 6.202 0 0 1-4.458-1.828A4.336 4.336 0 0 0 30 38.437a4.336 4.336 0 0 0-3.087 1.28 6.2 6.2 0 0 1-4.413 1.827 6.2 6.2 0 0 1-4.413-1.828 4.37 4.37 0 0 0-6.174 0A6.2 6.2 0 0 1 7.5 41.544a6.2 6.2 0 0 1-4.413-1.828A4.336 4.336 0 0 0 0 38.437v-1.874c1.667 0 3.234.648 4.413 1.828A4.336 4.336 0 0 0 7.5 39.669a4.336 4.336 0 0 0 3.087-1.278 6.247 6.247 0 0 1 8.826 0 4.336 4.336 0 0 0 3.087 1.278 4.336 4.336 0 0 0 3.087-1.278A6.197 6.197 0 0 1 30 36.563c1.667 0 3.234.648 4.413 1.828a4.393 4.393 0 0 0 3.118 1.278 4.34 4.34 0 0 0 3.056-1.278A6.197 6.197 0 0 1 45 36.563c1.667 0 3.234.648 4.413 1.828a4.336 4.336 0 0 0 3.087 1.278 4.336 4.336 0 0 0 3.087-1.278A6.197 6.197 0 0 1 60 36.563v1.874a4.336 4.336 0 0 0-3.087 1.28 6.2 6.2 0 0 1-4.413 1.827',
                fill: '#00D8C8',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                fill: '#3F5060',
                mask: 'url(#b)',
                d: 'M44.063 48.75h1.874v-1.875h-1.874zM29.063 48.75h1.875v-1.875h-1.875z'
            }),
            _react2.default.createElement('path', {
                d: 'M7.5 29.063c-1.034 0-1.875.84-1.875 1.875 0 1.034.84 1.875 1.875 1.875 1.034 0 1.875-.841 1.875-1.876 0-1.034-.84-1.875-1.875-1.875m0 5.625a3.754 3.754 0 0 1-3.75-3.75 3.754 3.754 0 0 1 3.75-3.75 3.754 3.754 0 0 1 3.75 3.75 3.754 3.754 0 0 1-3.75 3.75M52.5 29.063c-1.034 0-1.875.84-1.875 1.875 0 1.034.84 1.875 1.875 1.875 1.034 0 1.875-.841 1.875-1.876 0-1.034-.84-1.875-1.875-1.875m0 5.625a3.754 3.754 0 0 1-3.75-3.75 3.754 3.754 0 0 1 3.75-3.75 3.754 3.754 0 0 1 3.75 3.75 3.754 3.754 0 0 1-3.75 3.75',
                fill: '#FFCF3F',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                d: 'M17.813 10.313a8.437 8.437 0 0 0-8.438-8.438 8.437 8.437 0 0 0-8.438 8.438h16.875z',
                fill: '#F7F7F8',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                d: 'M1.934 9.375h14.882c-.462-3.695-3.623-6.563-7.441-6.563-3.818 0-6.98 2.868-7.441 6.563zM18.75 11.25H0v-.938C0 5.144 4.206.938 9.375.938s9.375 4.205 9.375 9.374v.938z',
                fill: '#3F5060',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                fill: '#3F5060',
                mask: 'url(#b)',
                d: 'M8.438 22.5h1.874V1.875H8.438z'
            }),
            _react2.default.createElement('path', {
                d: 'M5.655 9.375h7.44c-.255-3.912-2.075-6.563-3.72-6.563s-3.466 2.65-3.72 6.563zM15 11.25H3.75v-.938C3.75 5.056 6.221.938 9.375.938S15 5.056 15 10.312v.938zM27.188 19.688H16.614l-4.91-2.947.965-1.607 4.465 2.678h10.052z',
                fill: '#3F5060',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                fill: '#3F5060',
                mask: 'url(#b)',
                d: 'M15.938 22.5h1.874v-3.75h-1.875zM23.438 22.5h1.875v-3.75h-1.875z'
            })
        )
    );
};

DefaultIcon.defaultProps = {
    width: '60',
    height: '50',
    viewBox: '0 0 60 50',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
};

var ProfileIcon = function (_React$Component) {
    _inherits(ProfileIcon, _React$Component);

    function ProfileIcon() {
        _classCallCheck(this, ProfileIcon);

        return _possibleConstructorReturn(this, (ProfileIcon.__proto__ || Object.getPrototypeOf(ProfileIcon)).apply(this, arguments));
    }

    _createClass(ProfileIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || _sizes.Sizes.md;
            size = (0, _getSize2.default)(size);
            return _react2.default.createElement(
                _layout2.default,
                this.props,
                _react2.default.createElement(DefaultIcon, { fill: this.props.hover || this.props.active ? _colors.Colors.calmWhite : _colors.Colors.claimBlack, width: size + 'px', height: size + 'px' })
            );
        }
    }]);

    return ProfileIcon;
}(_react2.default.Component);

exports.default = ProfileIcon;